export { default } from './ArcadeChest.tsx'
